const parseUri = require('parse-uri');

const PATH_PREFIX = '/';
const PACKAGE_NAME = 'localizationUtils';

// eslint-disable-next-line complexity
function getLocalizedPath(urlPath, basePath) {
    // This will take pathname and siteContext({basePath, hostname}) and will return localized path.
    // For Example : If url pathname is /search and basePath is /en-ca,
    // it will return path - /en-ca/search

    if (basePath && urlPath.indexOf(basePath) !== 0) {
        return urlPath !== PATH_PREFIX ? `${basePath}${urlPath}` : basePath;
    }

    return urlPath;
}

/**
 * This function returns localized url according to provided basePath from siteContext.
 * It returns relative url if input is relative, and absolute url if input is absolute.
 * For relative url, please make sure it starts with '/'.
 * To localize relative url to absolute, set options with {absolute: true}
 *
 * @param url Absolute/relative url to be localized. Relative url must starts with '/'.
 * @param siteContext(basePath,hostname) Site context information, including basePath and hostname.
 * @param options \{absolute: true\} returns absolute localized url
 * @returns string
 */
// eslint-disable-next-line complexity
const localizeUrl = (url, siteContext = {}, options = {}) => {
    if (!url) {
        return url;
    }

    if (typeof siteContext.basePath !== 'string') {
        console.warn(`[${PACKAGE_NAME}] BasePath missing.`); // eslint-disable-line
    }

    const parsedUrl = parseUri(url);

    /** return if current site hostName doesn't match with url hostname **/
    if (parsedUrl.host && siteContext.hostname !== parsedUrl.host) {
        return url;
    }

    let path = getLocalizedPath(parsedUrl.relative, siteContext.basePath);

    if (parsedUrl.authority || options.absolute) {
        let host = parsedUrl.authority || siteContext.hostname;

        if (!host) {
            throw new Error(`[${PACKAGE_NAME}] Error: Hostname missing.`);
        }

        let scheme = parsedUrl.protocol || 'https';
        return `${scheme}://${host}${path}`;
    }
    return path;
};

module.exports = {
    localizeUrl
};
